'use strict';

angular.module('shiftTraderApp')
    .controller('ManageTemplatesDialogCtrl', function ($scope, $uibModalInstance, $uibModal, Session, ShiftTemplates, toastr,
                                                       TimeService, params, ShepherdTourService, saShiftTemplateAPILimit) {
      $scope.state = {
        viewActive: true,
        active: {
          loadingMore: false,
          showLoadMore: false,
          lastOffset: 0
        },
        archived: {
          loadingMore: false,
          showLoadMore: false,
          lastOffset: 0
        },
        loadingMore: false,
        showLoadMore: false
      };


      $scope.me = params.me;
      $scope.org = params.org;
      $scope.allDepartments = $scope.org.departments;
      $scope.allPositions = params.allPositions;
      $scope.allShiftTemplates = params.allShiftTemplates;

      if ($scope.allShiftTemplates.length >= saShiftTemplateAPILimit) {
        $scope.state.active.showLoadMore = true;
      }

      ShiftTemplates.getAll({
        archived: true
      })
        .then(function(archivedTemplates) {
          if (archivedTemplates.length >= saShiftTemplateAPILimit) {
            $scope.state.archived.showLoadMore = true;
          }

          $scope.allShiftTemplates = $scope.allShiftTemplates.concat(archivedTemplates);
          calculateTemplateViewList();
        }, function() {
          toastr.error('Failed to load archived templates. Please try to open the modal again to view archived.', 'Error');
        });

      $scope.templateViewDate = TimeService.getBeginningOfDayFromDate(moment().tz(Session.getTimezone()));

      $scope.close = function() {
        $uibModalInstance.close({
          allTemplates: $scope.allShiftTemplates
        });
      };

      $scope.applyTemplate = function(template) {
        $uibModalInstance.close({
          allTemplates: $scope.allShiftTemplates,
          applyTemplateId: template.id
        });
        ShepherdTourService.triggerEvent('manageTemplatesApplyTemplate', 500);
      };

      var calculateTemplateViewList = function() {
        if ($scope.state.viewActive) {
          $scope.state.showLoadMore = $scope.state.active.showLoadMore;
          $scope.state.loadingMore = $scope.state.active.loadingMore;
        } else {
          $scope.state.showLoadMore = $scope.state.archived.showLoadMore;
          $scope.state.loadingMore = $scope.state.archived.loadingMore;
        }

        $scope.templatesInList = _.where($scope.allShiftTemplates, function(shift) {
          return $scope.state.viewActive !== shift.archived && shift.active;
        });

      };

      calculateTemplateViewList();

      $scope.showActive = function() {
        $scope.state.viewActive = true;
        calculateTemplateViewList();
      };

      $scope.showArchived = function() {
        $scope.state.viewActive = false;
        calculateTemplateViewList();
      };


      $scope.loadMoreTemplates = function() {
        var params = {};

        if ($scope.state.viewActive) {
          params.offset = $scope.state.active.lastOffset + saShiftTemplateAPILimit;
          $scope.state.active.loadingMore = true;
          params.archived = false;
        } else {
          params.offset = $scope.state.archived.lastOffset + saShiftTemplateAPILimit;
          params.archived = true;
          $scope.state.archived.loadingMore = true;
        }

        // update the showLoadMore/loadingMore flags
        calculateTemplateViewList();

        ShiftTemplates.getAll(params)
          .then(function(moreTemplates) {
            if (params.archived) {
              $scope.state.archived.lastOffset = params.offset;
              $scope.state.archived.loadingMore = false;

              if (moreTemplates.length >= saShiftTemplateAPILimit) {
                $scope.state.archived.showLoadMore = true;
              } else {
                $scope.state.archived.showLoadMore = false;
              }

            } else {
              $scope.state.active.lastOffset = params.offset;
              $scope.state.active.loadingMore = false;

              if (moreTemplates.length >= saShiftTemplateAPILimit) {
                $scope.state.active.showLoadMore = true;
              } else {
                $scope.state.active.showLoadMore = false;
              }
            }

            $scope.allShiftTemplates = $scope.allShiftTemplates.concat(moreTemplates);
            calculateTemplateViewList();
          }, function() {

          });
      };

      $scope.selectTemplate = function(template) {
        template.shifts = _.map(template.shifts, function(shift) {
          shift.$setDateForTimeCalcs($scope.templateViewDate);
          return shift;
        });

        $scope.currentTemplateShifts = template.shifts;
        $scope.currentTemplateDepartments = _.where($scope.allDepartments, function(dept) {
          return _.any(template.shifts, function(shift) {
            return _.any(dept.positions,function(pos) {
              return pos.id === shift.position_id && pos.active;
            });
          });
        });
        $scope.currentTemplate = template;
        ShepherdTourService.triggerEvent('manageTemplatesSelectTemplate', 500);
      };


      $scope.editTemplate = function(template) {
        var temp = template;

        var modalInstance =  $uibModal.open({
          size: 'wide',
          keyboard: false,
          backdrop: 'static',
          templateUrl: 'views/quickCreateTemplateModal.html',
          controller: 'QuickCreateTemplateModalCtrl',
          resolve: {
            params: function() {
              return {
                me: $scope.me,
                org: $scope.org,
                allPositions: $scope.allPositions,
                originatingTemplate: template,
                mode: 'edit'
              };
            }
          }
        });

        modalInstance.result.then(function(result) {
          // result is dict with keys oldTemplate and newTemplate

          if (result) {
            $scope.allShiftTemplates.push(result.newTemplate);

            var idx = _.findIndex($scope.allShiftTemplates, {id: temp.id});

            if (idx > -1) {
              $scope.allShiftTemplates[idx] = result.oldTemplate;
            }
          }

          calculateTemplateViewList();
        });
      };

      $scope.cloneTemplate = function(template) {
        var modalInstance =  $uibModal.open({
          size: 'wide',
          keyboard: false,
          backdrop: 'static',
          templateUrl: 'views/quickCreateTemplateModal.html',
          controller: 'QuickCreateTemplateModalCtrl',
          resolve: {
            params: function() {
              return {
                me: $scope.me,
                org: $scope.org,
                allPositions: $scope.allPositions,
                originatingTemplate: template,
                mode: 'clone'
              };
            }
          }
        });

        modalInstance.result.then(function(result) {
          if (result) {
            $scope.allShiftTemplates.push(result.newTemplate);
            calculateTemplateViewList();
          }
          return result;
        });
      };

      $scope.removeTemplate = function(template) {
        template.$update({active:false})
            .then(function(data) {
              toastr.success('Removal of template ' + template.name + ' was successful.', 'Success');
              var idx = _.findIndex($scope.allShiftTemplates, function(st) {
                return st.id === data.id;
              });
              calculateTemplateViewList();
            }, function() {
              console.log('update failed');
              toastr.error('Template removal failed', 'Error');
            });
      };


      $scope.archiveTemplate = function(template) {
        template.$archive()
            .then(function() {
              toastr.success('Template archived.', 'Success');
              calculateTemplateViewList();
            }, function() {
              toastr.error('Template archival failed.', 'Error');
            });
      };

      ShepherdTourService.triggerEvent('manageTemplatesOpened', 500);
    });
